import luminaires from '@/store/devices/luminaires';
import gateways from '@/store/devices/gateways';
import switches from '@/store/devices/switches';
import calibrations from '@/store/devices/calibrations';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		gateways,
		luminaires,
		switches,
		calibrations,
	},
	actions: {
		async fetchAllDevices({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([
				dispatch('luminaires/fetchLuminaires'),
				dispatch('gateways/fetchGateways'),
				dispatch('switches/fetchSwitches'),
				dispatch('calibrations/fetchCalibrations'),
			]);
		},

		cleanAllDevices({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('luminaires/cleanAllLuminaire');
			dispatch('gateways/cleanAllGateways');
			dispatch('switches/cleanSwitches');
			dispatch('calibrations/cleanAllGateways');
		},
	},
};
